import { Button, HorizontalScroll, Tabs, TabsItem } from '$uikit';
import React, { useEffect } from 'react';
import { ListOfButtonSelectProps } from '$uikit/ListOfButtonSelect/ListOfButtonSelect.interface';
import './ListOfButtonSelect.sass';
import { useTranslator } from '$hooks';

export const ListOfButtonSelect = <T extends string>({
  setSelect,
  data,
  size = 'small',
  selectedIndex,
  setSelectedIndex,
}: ListOfButtonSelectProps<T>) => {
  const t = useTranslator();

  const onSelect = (value, index) => () => {
    setSelect?.(value);
    setSelectedIndex(index);
  };

  useEffect(() => {
    const select = data[selectedIndex]?.value;
    if (setSelect) {
      setSelect(select);
    }
  }, [selectedIndex]);

  return (
    <HorizontalScroll className={'filter'}>
      {data.map(({ label, value, count }, index) => (
        <Button
          onClick={onSelect(value, index)}
          key={label}
          mode={selectedIndex === index ? 'inverse' : 'quinary'}
          size={size}
        >
          {t(label)}
          {count && (
            <span
              className={`filter__count ${
                selectedIndex === index ? 'filter__count_active' : ''
              }`}
            >
              {count}
            </span>
          )}
        </Button>
      ))}
    </HorizontalScroll>
  );
};
